import React, { useState, useEffect, useMemo } from "react";
import { combineProviders } from "react-combine-providers";
import {
  PageNavigationProvider,
  usePageNavigation,
  PAGE,
  NAVIGATION_DIRECTION,
} from "./contexts/PageNavigationContext";
import { PageConfigurationProvider, usePageConfiguration } from "./contexts/PageConfigurationContext";
import ChannelSelectionPage from "./components/ChannelSelectionPage";
import ChannelHtmlCardPage from "./components/ChannelHtmlCardPage";
import ChannelSearchPage from "./components/ChannelSearchPage";
import "./style.css";

const TemplateContent = () => {
  const { currentPage, navigationDirection, previousPage, setNavigationDirection } = usePageNavigation();
  const { resetSelectedChannel } = usePageConfiguration();
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [pages, setPages] = useState({
    from: previousPage,
    to: currentPage,
  });

  useEffect(() => {
    if (navigationDirection === NAVIGATION_DIRECTION.NONE) return;

    setPages({ from: previousPage, to: currentPage });

    setIsTransitioning(true);
    const timer = setTimeout(() => {
      setIsTransitioning(false);
      setNavigationDirection(NAVIGATION_DIRECTION.NONE);
      resetSelectedChannel(currentPage.pageType);
    }, 500);

    return () => clearTimeout(timer);
  }, [currentPage, previousPage, navigationDirection, setNavigationDirection, resetSelectedChannel]);

  const transitionStyle = useMemo(() => {
    const isBackward = navigationDirection === NAVIGATION_DIRECTION.BACKWARD;

    if (!isTransitioning) {
      return {
        transform: isBackward ? "translateX(-50%)" : "translateX(0%)",
        transition: "none",
      };
    }

    return {
      transform: isBackward ? "translateX(0%)" : "translateX(-50%)",
      transition: "transform 0.5s ease-in-out",
    };
  }, [isTransitioning, navigationDirection]);

  const renderCurrentPage = (page) => {
    switch (page?.pageType) {
      case PAGE.CHANNEL_SELECTION:
        return <ChannelSelectionPage />;
      case PAGE.CHANNEL_HTML_CARD:
        return <ChannelHtmlCardPage />;
      case PAGE.CHANNEL_SEARCH:
        return <ChannelSearchPage />;
      default:
        return null;
    }
  };

  return (
    <div className="norstella-pf-carousel-wrapper">
      <div className="norstella-pf-slide-strip" style={transitionStyle}>
        {pages.from && navigationDirection === NAVIGATION_DIRECTION.FORWARD && (
          <div className="norstella-pf-page-slide">{renderCurrentPage(pages.from)}</div>
        )}
        {pages.to && <div className="norstella-pf-page-slide">{renderCurrentPage(pages.to)}</div>}
        {pages.from && navigationDirection === NAVIGATION_DIRECTION.BACKWARD && (
          <div className="norstella-pf-page-slide">{renderCurrentPage(pages.from)}</div>
        )}
      </div>
    </div>
  );
};

const DecisionTreeVS2Builder = ({ appliedConfiguration, debugMode, ...props }) => {
  const providers = new combineProviders();
  providers.push(PageConfigurationProvider);
  providers.push(PageNavigationProvider);
  const MasterProvider = providers.master();

  return (
    <MasterProvider>
      <TemplateContent {...props} />
    </MasterProvider>
  );
};

export default DecisionTreeVS2Builder;
